import { AutogenLayoutEquipWarningQuickInfo } from "./autogen/AutogenLayoutEquipWarningQuickInfo";
import { Label, Panel } from "@mcleod/components";
import { RegulatoryValidation, ExpirationValid, PlanningUtil } from "./PlanningUtil";

export class EquipWarningQuickInfo extends AutogenLayoutEquipWarningQuickInfo {
    private isDriver: boolean;
    private driverNum: number;
    private trailerNum: number;

    override onLoad(): void | Promise<void> {
        this.mainDataSource.addDisplayListener(() => this.showPanels());
    }

    public showPanels() {
        if (this.activeRow == null) {
            return;
        }
        if (this.isDriver) {
            this.driverNum ??= 1;
            this.labelLicenseDate.field = `driver${this.driverNum}_license_date`;
            this.labelPhysicalDate.field = `driver${this.driverNum}_physical_date`;
            this.labelMvrDate.field = `driver${this.driverNum}_mvr_date`;
            const results = PlanningUtil.driverRegulatoryValidations(this.activeRow, this.driverNum);
            this.showPanel(results.driverLicense, this.labelLicenseExpired, this.panelLicense);
            this.showPanel(results.driverPhysical, this.labelPhysicalExpired, this.panelPhysical);
            this.showPanel(results.driverMVR, this.labelMvrExpired, this.panelMvr);
        } else {
            this.trailerNum ??= 1;
            const results = PlanningUtil.tractorTrailerRegulatoryValidations(this.activeRow);
            switch (this.trailerNum) {
                case 1:
                    this.showPanel(results.tractorInspect, this.labelTractorInspectExpired, this.panelTractorInspection);
                    this.showPanel(results.trailerInspect, this.labelTrailerInspectExpired, this.panelTrailerInspection);
                    break;
                case 2:
                    this.showPanel(results.trailer2Inspect, this.labelTrailer2InspectExpired, this.panelTrailer2Inspection);
                    break;
                case 3:
                    this.showPanel(results.trailer3Inspect, this.labelTrailer3InspectExpired, this.panelTrailer3Inspection);
                    break;
            }
        }
    }

    private showPanel(item: RegulatoryValidation, label: Label, panel: Panel) {
        if (item) {
            label.text = ExpirationValid.ERROR == item.valid
                ? "EXPIRED"
                : `Expires in ${item.diff} Days`;
            panel.visible = true;
            panel.parent.visible = true;
        }
    }
}
